export default __webpack_public_path__ + "img/65beef7151b7e8fc2a7a8e6db6d85513.png";